<template>
  <div class="px-0 pb-0 card-body">
    <div v-if="loading && filteredData.length === 0" class="text-center py-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-2">Loading BDCOM EPON data...</p>
    </div>
    <div class="table-responsive" v-else-if="filteredData.length > 0">
      <div class="card mb-4">
        <div class="card-body px-0 pt-0 pb-2 invoice">
          <div class="table-responsive p-0">
            <table class="table align-items-center mb-0">
              <thead>
                <tr>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    Interface
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    ONU Interface
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    PPPOE ID
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    MAC Address
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    Last Registered
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    Last Deregistered
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    Dereg Reason
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(onu, index) in filteredData" :key="index">
                  <td class="align-middle text-center text-sm">
                    {{ onu.interface_name }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ onu.onu_interface }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    <span v-if="onu.PPPOE_ID === 'Loading...'">
                      <span class="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
                    </span>
                    <span v-else>
                      {{ onu.PPPOE_ID ?? 'N/A' }}
                    </span>
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ formatMacAddress(onu['MAC Address']) }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ formatDateTime(onu.LastRegTime) }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ formatDateTime(onu.LastDeregTime) }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ formatDeregReason(onu.LastDeregReason) }}
                  </td>
                  <td class="text-center">
                    <soft-badge
                      class="p-1 rounded-1 text-white cursor-pointer text-sm"
                      :class="getStatusBadgeClass(onu.Status)"
                      variant="gradient"
                      size="sm"
                    >
                      {{ onu.Status }}
                    </soft-badge>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <Skalaton />
    </div>
  </div>
</template>

<script>
import Skalaton from "@/components/Skalaton.vue";

export default {
  name: "BdcomEponTable",
  components: {
    Skalaton
  },
  props: {
    loading: Boolean,
    filteredData: {
      type: Array,
      default: () => []
    },
    sortKey: String,
    sortOrder: String
  },
  methods: {
    getStatusBadgeClass(status) {
      const statusLower = status.toLowerCase();
      if (statusLower.includes('deregistered')) return 'bg-danger';
      if (statusLower.includes('registered')) return 'bg-success';
      return 'bg-warning';
    },
    formatDateTime(datetime) {
      if (!datetime || datetime.includes('2000-01-01')) return 'N/A';
      return datetime;
    },
    formatMacAddress(mac) {
      if (!mac) return 'N/A';
      // Convert formats like a28c.0607.a9f0 to a2:8c:06:07:a9:f0
      return mac.toLowerCase()
        .replace(/[^a-f0-9]/g, '')
        .match(/.{1,2}/g)
        .join(':');
    },
    formatDeregReason(reason) {
      if (!reason) return 'N/A';
      return reason.split('-').map(word => 
        word.charAt(0).toUpperCase() + word.slice(1)
      ).join(' ');
    }
  }
};
</script>

<style scoped>
/* Your existing styles remain unchanged */
.table th {
  padding: 12px 24px !important;
}

.sort-icon {
  margin-left: 5px;
}

.asc::after {
  content: "▲";
}

.desc::after {
  content: "▼";
}

.bg-danger {
  background-color: #f56565 !important;
}

.bg-success {
  background-color: #48bb78 !important;
}

.bg-warning {
  background-color: #ed8936 !important;
}
</style>